import CloseButton from "../CloseButton/CloseButton"
import PrimaryButton from "../PrimaryButton/PrimaryButton"
import styles from "./Popup.module.scss"

interface Props {
  title: string
  ctaTitle: string
  visible: boolean
  headerImageClass?: string
  headerIcon?: React.ReactElement
  className?: string
  onClose: () => void
}

const Popup = (props: React.PropsWithChildren<Props>) => {
  return (
    <>
      <div
        className={`${styles.popup} ${props.visible ? styles.visible : ""} ${props.className || ""}`}
      >
        <div className={`${styles.popupContainer}`}>
          <CloseButton className={styles.closeButton} onClick={props.onClose} />
          <Header
            title={props.title}
            imageClass={props.headerImageClass}
            icon={props.headerIcon}
          />
          {props.children}
          <PrimaryButton onClick={props.onClose} className={styles.cta}>
            {props.ctaTitle}
          </PrimaryButton>
        </div>
      </div>
      <div
        className={`${styles.backgroundDarken} ${props.visible ? styles.visible : ""}`}
      ></div>
    </>
  )
}

const Header = ({ title, imageClass, icon }) => {
  return (
    <>
      <div className={`${styles.headerImage}`}>
        {icon ? icon : <div className={imageClass} />}
      </div>
      <div className={styles.headerTitle}>{title}</div>
    </>
  )
}

export default Popup
